import type { FaireProductEntity } from "../../entity_types/product";

export const p_p33yxznuea: FaireProductEntity = {
  token: "p_p33yxznuea",
  type: "product",
  name: "Mineral Shilajit",
  brandToken: "b_9lnqwiw9kl",
  brandName: "Cymbiotika",
  imageUrl:
    "https://cdn.faire.com/fastly/e6e5ddfee1a727517f6047de86576cf43d7ac0406e4132fa7de1ec0b1bf7c8db.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3634d3fcc7744e37a52912a5af3d33c90e6184b38ebc2f6c2074b6610c6c8915.jpeg",
    "https://cdn.faire.com/fastly/c269e8d5f8df73ad39936dbbd386e53cf016167b2ed6ab686c225f4d01dd5362.gif",
    "https://cdn.faire.com/fastly/40ddf1f7ef6f17ac4b866b0977a1b0b7e479d90306cdc6ad84d416ac759c38d6.png",
  ],
  priceDollars: 51.06,
  description:
    "Cymbiotika Shilajit Black Gold Live Resin® (15g net content) is a complex mineral nutrient sourced from high elevations in pristine parts of the world. Containing 84+ minerals, our pure Shilajit Resin is rich with fulvic acid, humic acid, vitamins, enzymes, tocopherols, bioflavonoids, antioxidants, and metabolites that combat free radicals in your body. Pure Shilajit extract has a positive effect that counters cellular damage and increases muscle strength, making it an excellent dietary supplement.\nThe dosage may be increased according to your needs. Can be taken daily, in the morning or at night.\nUsing the small scooper, measure out your desired dose of Shilajit resin. Place into a cup of warm water, tea, or coffee to dissolve as a healing elixir.\nStore: Keep in a cool, dark place or refrigerate after opening. Do not freeze.",
  tags: [],
  msrpDollars: 92.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:04.964Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
